<template>
  <div class="userEdit">


    <v-sheet class="my-5 d-md-flex">

      <v-sheet class="flex-sm-column">
        <p class="text-h4"> {{ id ? "Edit User" : "Create User" }}</p>

      </v-sheet>

      <v-sheet class="flex-sm-column">
        <v-breadcrumbs class="pa-md-3 pa-0 mb-4 ">
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }">Home</v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'user', params: {} }">
            User
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'userEdit', params: { id: id } }">
            Edit User
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-sheet>
    </v-sheet>

    <user-form :id="id"></user-form>
  </div>
</template>

<script>
import UserForm from "./UserForm.vue";

export default {
  name: "user",
  data() {
    return {
      id: null
    };
  },
  components: {
    UserForm
  },
  created() {
    this.id = this.$route.params.id;
    this.$emit("showParent", false);
  }
};
</script>
